module.exports = __webpack_public_path__ + "static/media/thumbnail.317795a4.jpg";